/**
 * PreviousNumberTile — secondary tile.
 * Per design: ~25% of hero size, muted, placed bottom-left of the hero.
 */
export default function PreviousNumberTile({ value }) {
  return (
    <div
      data-testid="projector-previous-number"
      className="ic-font-display flex flex-col items-center justify-center rounded-2xl border select-none"
      style={{
        width: "clamp(8rem, 10vw, 14rem)",
        height: "clamp(8rem, 10vw, 14rem)",
        background: "var(--ic-bg-elevated)",
        borderColor: "var(--ic-border-subtle)",
      }}
    >
      <span
        className="text-[10px] tracking-[0.35em] uppercase"
        style={{ color: "var(--ic-text-muted)" }}
      >
        Previous
      </span>
      <span
        className="font-bold leading-none mt-2"
        style={{
          fontSize: "clamp(3rem, 5vw, 6rem)",
          color: "var(--ic-text-secondary)",
        }}
      >
        {value ?? "—"}
      </span>
    </div>
  );
}
